
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 482 482"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M279.8 244.8l-21.6 12.5V482l194.5-112.3V145zM315 43.3L240.2 0 40.3 115.4l74.9 43.3zM440 115.4l-86.2-49.1L154 181.7l11.4 5.9 74.8 43.2 74.4-42.9zM138.9 264.3l-35.8-18.4v-57.2l-73.8-42.5v223.1l193.1 111.5V257.7l-83.5-48.1z"}})])
          )
        }
      }
    